export const defaultLang: string = 'lv';
